import Joi from 'joi';
const trackChartInteractionSchema = Joi.object({
    eventName: Joi.string()
        .required()
        .min(1),
    mixpanelPayload: Joi.object().required(),
});
export const validateTrackChartInteractionPayload = (payload, isTsHostedChart) => {
    if (isTsHostedChart === false) {
        throw new Error('TrackChartInteraction is not supported for non TS hosted charts');
    }
    try {
        Joi.assert(payload, trackChartInteractionSchema);
    }
    catch (err) {
        throw new Error(err.details?.[0]?.message || 'Invalid payload');
    }
};
//# sourceMappingURL=utils.js.map